@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.voiceassistant

import com.narbase.letsgo.router.EndPoint

object GetVoiceAssistantSessionAudioEndpoint :
    EndPoint<GetVoiceAssistantSessionAudioEndpoint.Request, GetVoiceAssistantSessionAudioEndpoint.Response>() {
    class Request(val turnId: String)
    class Response(
        val audioBase64: String?,
        val audioMimeType: String?,
    )
}
